import { useState, useEffect } from "react";
import { __callbacks } from "Utils/Callbacks/Callback";
import { AppState } from 'Utils/Enums';
import styles from "./StartConversation.module.scss";
import { __bot } from "Utils/Bot/Bot"; // Import the bot instance
import { __config } from "Utils/Configs/Config"; // Import the config instance

export default function ButtonSendMessage() {
    const [buttonText, setButtonText] = useState("Send us a message");

    useEffect(() => {
        // Log the config to verify it is loaded
        if (__config.config && __config.config.containersMetaData?.containers?.startConversation?.button?.text) {
            setButtonText(__config.config.containersMetaData.containers.startConversation.button.text);
        }
    }, []);

    const onClick = () => {
        __callbacks.startNewChat.trigger({
            backState: AppState.home
        });

        __callbacks.focusChatInput.trigger({});
        __callbacks.hideCollections.trigger({});

        // Reset bot
        __bot.setStatusInProgress();
    }

    return (
        <div className={`${styles["container-btn-send-msg"]} config--continueConversation-button`} onClick={onClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                <path d="M1.40362 15.3409C0.417688 15.8509 -0.180418 15.3951 0.0683394 14.3202L1.08878 9.91078C1.21312 9.37347 1.75105 8.88843 2.30788 8.82543L8.50342 8.12441C10.1512 7.93797 10.157 7.63892 8.50342 7.455L2.30788 6.76592C1.75893 6.70487 1.21294 6.21784 1.08878 5.67988L0.0683394 1.25866C-0.18014 0.182085 0.408942 -0.281766 1.40362 0.232725L14.223 6.86346C15.209 7.37342 15.2177 8.19572 14.223 8.71021L1.40362 15.3409Z" />
            </svg>
            <span>{buttonText}</span>
        </div>
    )
}
